import React, { Component } from "react";
import Header from "../header";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

class RecentVisit extends Component {
  state = {
    RecentVisit: [],
    loading: true,
  };

  componentDidMount() {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/user/Last_visit`, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loading: false, RecentVisit: res.data.data });
      });
  }

  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #FAFAFA !important;
    }`;

    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={"بازدید های اخیر"}
              isDarkTheme={false}
              backUrl={"/profile"}
            />
            <main className="MyFavorite">
              {this.state.RecentVisit.map((item, index) => (
                <div className="Favorite" key={index}>
                  <div className="FavoriteImage">
                    <img src={item.image} alt="عکس محصول" />
                  </div>
                  <div className="FavoriteGoldeston">
                    <span className="title">{item.name}</span>
                  </div>
                  {item.price != 0 ? (
                    item.percent_price ? (
                      <>
                        <div className="FavoriteCost">
                          <span className="FavDiscount">
                            {item.percent_price} %
                          </span>
                          <span className="FavoritePrice realPrice">
                            {(+item.price).toLocaleString()} تومان
                          </span>
                        </div>
                        <div className="sectionPrice">
                          <span className="FavoritePrice">
                            {item.old_price.toLocaleString()} تومان
                          </span>
                        </div>
                      </>
                    ) : (
                      <div className="sectionPrice">
                        <span className="FavoritePrice">
                          تومان {(+item.price).toLocaleString()}
                        </span>
                      </div>
                    )
                  ) : (
                    <div className="noStock">
                      <span className="noStock danger">ناموجود</span>
                    </div>
                  )}
                  <div className="viewSection ">
                    <Link to={`/product/${item.slug}`}>
                      <button className="btn btn--recentAddShow">مشاهده</button>
                    </Link>
                  </div>
                </div>
              ))}
            </main>
          </>
        )}
      </>
    );
  }
}
export default RecentVisit;
